import { Component, OnInit, Input, forwardRef } from '@angular/core';

import { PhotoGalleryListComponent } from '@app/components';

@Component({
    selector: 'app-store-details-photos',
    templateUrl: './photos.component.html',
    styleUrls: ['./photos.component.scss'],
    imports: [forwardRef(() => PhotoGalleryListComponent)]
})
export class StoreDetailsPhotosComponent  implements OnInit {

    @Input({alias : 'storeCode', required : true}) storeCode: string;

    constructor() { }

    ngOnInit() {}

}
